module.exports = __webpack_public_path__ + "img/rank-2.fa140775.svg";